<template>
    <v-card class="mx-auto">
        <v-toolbar flat >
            <v-row align="center" align-content="center" justify="center"  >
                <v-col cols="4">
                    <v-text-field :rules="[rules.required]" v-model="nome" label="Nome" hide-details></v-text-field>
                </v-col> 
                <v-col cols="4">
                    <v-text-field :rules="[rules.required]" v-model="email" type="email" label="e-Mail" hide-details></v-text-field>
                </v-col>       
                <v-col cols="3">
                    <v-select v-model="perfil" :items="items" label="Perfil" hide-details></v-select>
                </v-col>                            
                <v-col cols="1">
                    <v-btn color="primary" fab small dark @click="saveConfig">
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>    
                </v-col>                             
            </v-row> 
        </v-toolbar>
        <v-divider></v-divider> 
        <v-card-text> 
            <v-card v-for="item in this.usuarios" :key="item.id" tile>
                <v-row align="center" justify="center" dense>
                    <v-col cols="3">                  
                        <span class="title"> {{item.nome}} </span>
                    </v-col>
                    <v-col cols="3" >                  
                        <span class="title"> {{item.email}} </span>             
                    </v-col>
                    <v-col cols="2" >          
                            <v-switch 
                                v-model="item.ativo" 
                                :label="(item.ativo)?'Ativo':'Inativo'" 
                                :color="(item.ativo)?'primary':'red'"
                                @change="changeStatus(item)">
                            </v-switch>                                
                    </v-col>
                    <v-col cols="2">    
                        <v-select v-model="item.perfil" :items="items" label="Perfil" hide-details @change="changeStatus(item)"></v-select>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </v-card>              
        </v-card-text>   
    </v-card> 
</template>
<script>
import {db} from '@/main'
// import firebase from "firebase"

    export default {
        data(){
            return{
                rules: {
                    required: value => !!value || 'Campo Obrigatório.',
                },
                items: ['Administrador','Gerente','Atendente','Marketing'],
                nome: '',
                email: '',
                perfil: 'Administrador',
                usuarios: ''
            }
        },
        created(){
            this.companyId = this.$store.getters.company.data.id
            let company = db.collection('empresas').doc(this.companyId)
            db.collection('usuarios').where('empresa','==',company).get()
            .then((users) => {                           
                this.usuarios = users.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a});
                console.log('users',this.usuarios)                
            }).catch(function (error) {
                console.error("Error get users: ", error);
            });            
        },
        methods:{
            changeStatus(item){
                console.log(item)
                let user = {
                    'ativo': item.ativo,
                    'perfil': item.perfil
                }  
                db.collection('usuarios').doc(item.id).update(user).then(async() => {
                    this.loading = false
                    let success = {
                        'active':true,
                        'color':'success',
                        'message':'Usuário Atualizado com Sucesso'
                    }                
                    //await this.reloadData(this.$store.getters.company.data.id)
                    this.$emit("loadMessage",success)
                    // this.$emit("listEdit")
                    // this.clearFields()
                }).catch(function (error) {
                    let errorMessage = {
                        'active':true,
                        'color':'error',
                        'message': error
                    }          
                    console.error('Error to Save Config - teamPage: ' + error)
                    this.$emit("loadMessage",errorMessage)
                })                              
            },
            saveConfig(){
                let user = {
                    'nome': this.nome,
                    'email': this.email,
                    'empresa': db.collection('empresas').doc(this.companyId),
                    'ativo': false,
                    'perfil': this.perfil
                }
                // firebase.auth().createUserWithEmailAndPassword(user.email, '123456').then(authInfo => {
                //     console.log("deuCerto",authInfo)
                // }).catch(function(error) {
                //     // Handle Errors here.
                //     var errorCode = error.code;
                //     var errorMessage = error.message;
                //     console.log(errorCode,errorMessage)
                //     // ...
                // });

                
                db.collection('usuarios').add(user).then(async() => {
                    this.loading = false
                    let success = {
                        'active':true,
                        'color':'success',
                        'message':'Usuário Cadastrado com Sucesso'
                    }                
                    //await this.reloadData(this.$store.getters.company.data.id)
                    this.$emit("loadMessage",success)
                    // this.$emit("listEdit")
                    // this.clearFields()
                }).catch(function (error) {
                    let errorMessage = {
                        'active':true,
                        'color':'error',
                        'message': error
                    }          
                    console.error('Error to Save Config - AttendPage: ' + error)
                    this.$emit("loadMessage",errorMessage)
                })                 
            },
            loadMessage(value){
                this.$emit("loadMessage", value);            
            }
        }
    }
</script>